import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { memo } from "react";
import { CopyToWorkspacePanel } from "~/components/CopyToWorkspace/CopyToWorkspacePanel";
export const PublicClipActivityContainer = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "fixed bottom-6 right-4",
            children: /*#__PURE__*/ _jsx(CopyToWorkspacePanel, {})
        })
    });
});
PublicClipActivityContainer.displayName = "PublicClipActivityContainer";
